package one.healthium.ui.compose.components

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerEventPass
import androidx.compose.ui.input.pointer.PointerInputChange
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

@Composable
fun AppLoadingScreen(
    modifier: Modifier = Modifier,
    visible: Boolean = true,
    dim: Boolean = false,
    isDark: Boolean = true,
    progressIndicatorSize: Dp? = null,
    progressIndicatorStrokeWidth: Dp = 4.dp,
) {
    AnimatedVisibility(
        modifier = modifier,
        visible = visible,
        enter = fadeIn(),
        exit = fadeOut(),
    ) {
        var modifier = Modifier.fillMaxSize()
        if (dim) {
            modifier = modifier
                .dim(isDark)
                .pointerInput(Unit) {
                    awaitPointerEventScope {
                        while (true) {
                            awaitPointerEvent(pass = PointerEventPass.Initial)
                                .changes
                                .forEach(PointerInputChange::consume)
                        }
                    }
                }
        }
        Box(
            modifier = modifier,
            contentAlignment = Alignment.Center,
        ) {
            CircularProgressIndicator(
                modifier = if (progressIndicatorSize != null) Modifier.size(progressIndicatorSize) else Modifier,
                strokeWidth = progressIndicatorStrokeWidth,
            )
        }
    }
}

fun Modifier.dim(isDark: Boolean): Modifier =
    this.background(
        if (isDark) Color.Black.copy(alpha = 0.3f)
        else Color.White.copy(alpha = 0.3f)
    )
